import { Avatar } from '../app/core/models/avatar-model';

export const USERS: Avatar[] = [
  {
    oid: '11111111-0000-0000-0000-000000000001',
    displayName: 'A. Meyer',
    egeckoId: 'EM001',
    createdAt: '2025-01-10T08:00:00Z',
    lastAccessAt: '2026-05-01T09:30:00Z',
    roles: ['QSApp.Admin'],
    scopes: ['QSApp.Admin.UI'],
    department: { kstId: 531, displayName: 'Digitale Dienste & Software-Entwicklung' },
  },
  {
    oid: '11111111-0000-0000-0000-000000000002',
    displayName: 'B. Schulz',
    egeckoId: 'ES002',
    createdAt: '2025-02-01T08:00:00Z',
    lastAccessAt: '2026-04-28T14:00:00Z',
    roles: [],
    scopes: [],
    department: { kstId: 532, displayName: 'Projektmanagement' },
  },
  {
    oid: '11111111-0000-0000-0000-000000000003',
    displayName: 'C. Sommer',
    egeckoId: 'ES003',
    createdAt: '2025-03-15T08:00:00Z',
    lastAccessAt: '2026-05-02T10:15:00Z',
    roles: [],
    scopes: [],
    department: { kstId: 533, displayName: 'Qualitätssicherung' },
  },
  {
    oid: '11111111-0000-0000-0000-000000000004',
    displayName: 'D. König',
    egeckoId: 'EK004',
    createdAt: '2025-04-01T08:00:00Z',
    lastAccessAt: '2026-04-30T16:45:00Z',
    roles: [],
    scopes: [],
    department: { kstId: 534, displayName: 'Infrastruktur & Betrieb' },
  },
  {
    oid: '11111111-0000-0000-0000-000000000005',
    displayName: 'E. Weber',
    egeckoId: 'EW005',
    createdAt: '2025-05-20T08:00:00Z',
    lastAccessAt: '2026-05-03T08:00:00Z',
    roles: [],
    scopes: [],
    department: { kstId: 531, displayName: 'Digitale Dienste & Software-Entwicklung' },
  },
];
